var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Modal from '../../app2/Components/ComponentModal';
import Button from '../../app2/Components/ComponentButton';
import T from '../../app/Locale';
import ComponentInput from '../../app2/Components/ComponentInput';
function ModalDelete({ document, onClose }) {
    const [isLoading, setIsLoading] = useState(false);
    const [userTypedName, setUserTypedName] = useState('');
    const documentName = T.translate(`products.${document.type}.title`);
    function deleteDocument() {
        return __awaiter(this, void 0, void 0, function* () {
            setIsLoading(true);
            try {
                yield axios.post(`/my-documents/delete/${document.id}`);
                window.location.reload();
            }
            catch (error) {
                setIsLoading(false);
            }
        });
    }
    return (_jsxs(Modal, Object.assign({ closeModal: onClose }, { children: [_jsx("h3", { children: T.translate('documents.delete.title') }), _jsx("p", { children: T.translate('documents.delete.content', { document: T.translate(`products.${document.type}.title`) }) }), _jsx(ComponentInput, { id: 'document-delete-validate-name', placeholder: T.translate('documents.delete.input', { document: T.translate(`products.${document.type}.title`) }), onChange: (value) => setUserTypedName(value), value: userTypedName }), _jsx("br", {}), _jsx(Button, { id: 'document-delete-validate-submit', onClick: deleteDocument, title: T.translate('documents.delete.proceed'), isLoading: isLoading, isDisabled: userTypedName !== documentName || isLoading })] })));
}
ModalDelete.propTypes = {
    document: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};
export default ModalDelete;
